import { render, staticRenderFns } from "./combined.vue?vue&type=template&id=556ba778&scoped=true"
import script from "./combined.vue?vue&type=script&lang=js"
export * from "./combined.vue?vue&type=script&lang=js"
import style0 from "../asset/css/testPaperDetails.scss?vue&type=style&index=0&id=556ba778&prod&lang=scss&scoped=true&external"
import style1 from "./combined.vue?vue&type=style&index=1&id=556ba778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556ba778",
  null
  
)

export default component.exports